import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=21115d76"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=21115d76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports